var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('TransactionListDialog',{attrs:{"dialog":_vm.dialog,"title":"Transaction History","max-height":"500px","max-width":"950px","items":_vm.transactions,"show-type":"true"},on:{"closeDialog":_vm.hideDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }